/**
 * Corner radius tokens for consistent rounding
 * Values are in pixels, not spacing multipliers
 *
 * Names the radii the app already draws with, so a new component asks for the
 * kind of thing it is rather than for a number.
 */

export const borderRadius = {
  chip: 6,     // 6px - chips and other small inline badges
  control: 8,  // 8px - buttons and segmented controls
  card: 12,    // 12px - cards and the panels that behave like them
  pill: 20,    // 20px - fully rounded inputs
} as const

export type BorderRadius = keyof typeof borderRadius
